<div [class]="{ unselected: isUnselected, selected: isSelected, added: isAdded }" class="tag">
  @if (isSelected) {
    <span aria-hidden="true" class="icon icon-check icon-front"></span>
  }
  @if (isUnselected) {
    <span aria-hidden="true" class="icon icon-plus icon-front"></span>
  }
  <span class="tag-text"><ng-content></ng-content></span>
  @if (isAdded) {
    <span aria-hidden="true" class="icon icon-x icon-end"></span>
  }
</div>
